import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0f8aa2d1&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f8aa2d1')) {
      api.createRecord('0f8aa2d1', component.options)
    } else {
      api.reload('0f8aa2d1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0f8aa2d1&", function () {
      api.rerender('0f8aa2d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/runGroup/index.vue"
export default component.exports